<template>
  <div>
    <v-container>

      <v-card style="background-color: white;">
        <div style="display: flex; padding: 15px; margin-bottom: 10px;">
          <v-text-field hide-details type="date" v-model="dateLogs" outlined dense
            style=" max-width: 200px; margin-left: 20px;">
          </v-text-field>
          <v-select :items="logFiles" v-model="logFileChoosed" hide-details outlined dense label="מחלקה"
            :item-text="'hebrewName'" :item-value="'name'" style="max-width: 200px; margin-left: 20px;">
          </v-select>
          <v-select v-if="logFileChoosed && logFileChoosed === 'web-app'" :items="logWebTypes"
            v-model="logTypeWebChoosed" hide-details outlined dense label="סוג לוגים"
            style="max-width: 200px; margin-left: 20px;">
          </v-select>
          <v-select v-else-if="logFileChoosed && logFileChoosed === 'asterisk'" :items="logAsteriskTypes"
            v-model="logTypeAsteriskChoosed" hide-details outlined dense label="סוג לוגים" :item-text="'hebrewName'"
            :item-value="'name'" style="max-width: 200px; margin-left: 20px;">
          </v-select>

          <v-btn color="#0d2c6d" dark class="mb-2" style="max-width: 20px; " @click="getLogs()">
            אישור
          </v-btn>

          <v-btn outlined small class="mb-2 ms-4" style="max-width: 20px; margin-right: 70px !important;"
            @click="refreshDetails()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" dark>
                  mdi-refresh
                </v-icon>
              </template>
              <span>רענן תוצאות</span>
            </v-tooltip>
          </v-btn>

          <v-text-field label="חיפוש" style="max-width: 300px; margin-right: 30px;" hide-details outlined dense
            v-model="search" @input="debouncedSearch" clearable>
          </v-text-field>

        </div>
        
        <v-row v-if="progressShow" class="my-5">
          <v-col class="d-flex justify-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
        
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-bottom: 10px;">
          <span style="margin-right: 10px;">
            מציג: {{ displayedLogs.length }} שורות
            <span v-if="filteredLogs.length !== logs.length"> | סוננו: {{ filteredLogs.length.toLocaleString() }}</span>
            <span v-if="logs.length > 0"> | סה"כ: {{ logs.length.toLocaleString() }}</span>
            <span v-if="loadedLines > 0 && loadedLines !== logs.length"> (טוען... {{ loadedLines.toLocaleString() }})</span>
          </span>
        </div>

        <div style="overflow-y: auto; height: 65vh;" class="systembody">
          <div v-if="logFileChoosed === 'web-app'">
            <div v-for="(log, index) in displayedLogs" :key="index"
                 style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              {{ log.date }} {{ log.time }}
              <span :class="getClass(log.level)">
                [{{ log.level }}]
              </span>
              <p class="log-message" v-html="formatLogWebMessage(log.message)"></p>
            </div>
          </div>
          
          <div v-else-if="logFileChoosed === 'asterisk' && logTypeAsteriskChoosed !== 'costume'">
            <div v-for="(log, index) in displayedLogs" :key="index"
                 style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              <p v-html="formatLogAsteriskMessage(log)"></p>
            </div>
          </div>
          
          <div v-else-if="logFileChoosed === 'asterisk' && logTypeAsteriskChoosed === 'costume'">
            <div v-for="(log, index) in displayedLogs" :key="index"
                 style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              <p v-html="formatCostumeLogAsteriskMessage(log)"></p>
            </div>
          </div>
        </div>

        <!-- Pagination Controls at Bottom -->
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 10px; border-top: 1px solid #e0e0e0; background-color: #f5f5f5;">
          <v-select 
            :items="pageSizeOptions" 
            v-model="pageSize" 
            hide-details 
            outlined 
            dense 
            label="שורות לעמוד"
            style="max-width: 150px;"
            @change="changePageSize">
          </v-select>
          
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-btn icon small @click="goToPage(1)" :disabled="currentPage === 1 || progressShow">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
            <v-btn icon small @click="previousPage" :disabled="currentPage === 1 || progressShow">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            
            <span style="min-width: 120px; text-align: center; font-weight: 500;">
              עמוד {{ currentPage }} מתוך {{ totalPages }}
            </span>
            
            <v-btn icon small @click="nextPage" :disabled="currentPage >= totalPages || progressShow">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon small @click="goToPage(totalPages)" :disabled="currentPage >= totalPages || progressShow">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
          </div>
        </div>

      </v-card>
    </v-container>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </div>
</template>

<script>

import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'

export default {

  components: {
    SnackBar
  },
  data: () => ({
    overlay: false,
    editPlanDialog: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    progressShow: false,
    logs: [],
    displayedLogs: [],
    loadedLines: 0,
    dateLogs: "",
    logFileChoosed: "asterisk",
    logTypeWebChoosed: "הכל",
    logTypeAsteriskChoosed: "costume",
    logFiles: [{ name: "asterisk", hebrewName: "אסטריסק" }, { name: "web-app", hebrewName: "אתר הניהול" }],
    logWebTypes: ["הכל", "שגיאות", "מידע"],
    logAsteriskTypes: [{ name: "costume", hebrewName: "לוגים מותאם אישית" }, { name: "details", hebrewName: "מידע כללי" }, { name: "debug", hebrewName: "דיבאג" }, { name: "security", hebrewName: "אבטחה" }],
    search: "",
    searchTimer: null,
    filteredLogs: [], // לוגים אחרי סינון
    colorCache: {},
    usedColors: [],
    maxColorCache: 10,
    
    // Pagination
    currentPage: 1,
    pageSize: 500,
    pageSizeOptions: [100, 500, 1000, 2000],
    totalLines: 0
  }),
  
  computed: {
    totalPages() {
      return Math.ceil(this.filteredLogs.length / this.pageSize) || 1;
    }
  },
  
  methods: {
    async getLogs() {
      try {
        this.logs = [];
        this.filteredLogs = [];
        this.displayedLogs = [];
        this.loadedLines = 0;
        this.totalLines = 0;
        this.currentPage = 1;
        this.search = ""; // נקה חיפוש
        this.progressShow = true;
        
        let token = localStorage.getItem("token");
        
        // טען את כל הלוגים (ללא חיפוש - נעשה אותו מקומית)
        let api = process.env.VUE_APP_BASE_URL + 
          `/logs/get_today_logs?date=${this.dateLogs}&fileType=${this.logFileChoosed}&logType=${this.logTypeAsteriskChoosed}`;
        
        const response = await fetch(api, ApiServices.requestOptions("GET", "", token));
        
        if (response.status >= 400) {
          this.progressShow = false;
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let chunksReceived = 0;

        while (true) {
          const { done, value } = await reader.read();
          
          if (done) break;
          
          buffer += decoder.decode(value, { stream: true });
          
          // Process line by line (NDJSON format)
          const lines = buffer.split('\n');
          
          // Keep the last incomplete line in buffer
          buffer = lines.pop() || '';
          
          // Process each complete line
          for (const line of lines) {
            if (!line.trim()) continue;
            
            try {
              const chunk = JSON.parse(line);
              
              if (chunk.batch && chunk.batch.length > 0) {
                this.logs.push(...chunk.batch);
                this.loadedLines = chunk.count;
                chunksReceived++;
              }
              
              // Last chunk received
              if (chunk.isLast) {
                this.totalLines = chunk.count;
              }
            } catch (e) {
              console.error('Failed to parse chunk:', e, line);
            }
          }
        }

        this.progressShow = false;
        
        // אחרי שטענו הכל, אתחל את filteredLogs
        this.filteredLogs = [...this.logs];
        
        if (this.logFileChoosed === "asterisk") {
          this.formatLogsAsteriskData();
        } else {
          this.formatLogsWebData();
        }
        
        // עדכן את התצוגה לעמוד הראשון
        this.updateDisplayedLogs();
        
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get logs: " + error, "red");
      }
    },
    
    debouncedSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.filterLogs();
      }, 300);
    },
    
    filterLogs() {
      // אם אין חיפוש, הצג הכל
      if (!this.search || this.search.trim() === '') {
        this.filteredLogs = [...this.logs];
      } else {
        // סנן את הלוגים לפי החיפוש
        const searchLower = this.search.toLowerCase();
        this.filteredLogs = this.logs.filter(log => {
          if (typeof log === 'string') {
            return log.toLowerCase().includes(searchLower);
          }
          return false;
        });
      }
      
      // חזור לעמוד 1 אחרי חיפוש
      this.currentPage = 1;
      this.updateDisplayedLogs();
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateDisplayedLogs();
      }
    },
    
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateDisplayedLogs();
      }
    },
    
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.updateDisplayedLogs();
      }
    },
    
    changePageSize() {
      // כשמשנים את גודל העמוד, חזור לעמוד 1
      this.currentPage = 1;
      this.updateDisplayedLogs();
    },
    
    updateDisplayedLogs() {
      // חשב את הטווח לעמוד הנוכחי
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      
      // קח רק את השורות לעמוד הנוכחי מהלוגים המסוננים
      const pageData = this.filteredLogs.slice(startIndex, endIndex);
      
      if (this.logFileChoosed === "asterisk") {
        this.displayedLogs = [...pageData];
      } else {
        // web-app - פרמט את הנתונים
        this.displayedLogs = pageData.map(line => {
          const parts = line.split(' ');
          return {
            date: parts[0],
            time: parts[1],
            level: parts[2],
            message: parts.slice(3).join(' ')
          };
        });
      }
      
      this.applyFilters();
    },
    
    formatLogsWebData() {
      // עכשיו רק מעדכן את התצוגה לעמוד הנוכחי
      this.updateDisplayedLogs();
    },
    
    formatLogsAsteriskData() {
      // עכשיו רק מעדכן את התצוגה לעמוד הנוכחי
      this.updateDisplayedLogs();
    },
    
    applyFilters() {
      let filtered = [...this.displayedLogs];
      
      // Filter by log type (web-app only)
      if (this.logFileChoosed === 'web-app') {
        if (this.logTypeWebChoosed === "שגיאות") {
          filtered = filtered.filter(
            (log) => log.level === "error:" || log.level === "exception:"
          );
        } else if (this.logTypeWebChoosed === "מידע") {
          filtered = filtered.filter(
            (log) => log.level !== "error:" && log.level !== "exception:"
          );
        }
      }
      
      this.displayedLogs = filtered;
    },
    
    formatLogWebMessage(message) {
      const keywords = /\b(SessionId|DataName|TableName|By|Message|Item|Error)\b/g;
      return message.replace(keywords, '<strong>$1</strong>');
    },
    
    formatLogAsteriskMessage(message) {
      const keywords = /\b(VERBOSE|Caller|Answer|NoOp|Goto|Set|AGI|Playing|GotoIf|DTMF|IVR)\b/g;
      const callPattern = /\[C-0000[^\]]*\]/g;

      message = message.replace(keywords, '<strong>$1</strong>');

      message = message.replace(callPattern, (match) => {
        if (!this.colorCache[match]) {
          if (this.usedColors.length >= this.maxColorCache) {
            this.usedColors.shift();
          }
          const newColor = this.getRandomColor();
          this.colorCache[match] = newColor;
          this.usedColors.push(newColor);
        }
        return `<span style="color:${this.colorCache[match]};">${match}</span>`;
      });

      return message;
    },
    
    formatCostumeLogAsteriskMessage(message) {
      const keywords = /\b(INFO|ERROR|EXCEPTION|CONTROL_STREAM_FILE|STREAM_FILE|PLAYBACK|READ_DIGITS|ENTER|DTMF|HANGUP|IVR|API|LINE_NUMBER|CALLER_ID|CONTEXT|Message)\b/g;
      const channelIdPattern = /CHANNEL_ID: [^,]+/;

      message = message.replace(keywords, (match) => {
        if (match === 'ERROR' || match === 'EXCEPTION') {
          return `<strong class="error-keyword">${match}</strong>`;
        } else {
          return `<strong class="keyword">${match}</strong>`;
        }
      });

      message = message.replace(channelIdPattern, (match) => {
        if (!this.colorCache[match]) {
          if (this.usedColors.length >= this.maxColorCache) {
            this.usedColors.shift();
          }
          const newColor = this.getRandomColor();
          this.colorCache[match] = newColor;
          this.usedColors.push(newColor);
        }
        const channelValue = match.replace("CHANNEL_ID: ", "");
        const channelTitle = "CHANNEL_ID: ";
        return `<span style="font-weight: bold;">${channelTitle}</span><span style="color:${this.colorCache[match]}; font-weight: bold;">${channelValue}</span>`;
      });

      return message;
    },
    
    getRandomColor() {
      const randomComponent = () => {
        return Math.floor(Math.random() * (192 - 32) + 32).toString(16).padStart(2, '0');
      };

      let color = `#${randomComponent()}${randomComponent()}${randomComponent()}`;
      while (this.usedColors.includes(color)) {
        color = `#${randomComponent()}${randomComponent()}${randomComponent()}`;
      }
      return color;
    },
    
    getClass(level) {
      return level === 'info:' ? 'level-info' : 'level-error';
    },
    
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    
    setDateLogsToCurrentDate() {
      const today = new Date();
      const formattedDate = today.toISOString().substr(0, 10);
      this.dateLogs = formattedDate;
    },
    
    refreshDetails() {
      this.search = "";
      this.currentPage = 1;
      this.getLogs();
    }
  },
  
  created() {
    this.setDateLogsToCurrentDate();
  },
  
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }
}
</script>

<style scoped>
:deep(.keyword) {
  font-weight: bold;
  color: #0d47a1;
}

:deep(.error-keyword) {
  font-weight: bold;
  color: #d32f2f;
}

.level-info {
  color: rgb(24, 197, 24);
}

.level-error {
  color: red;
}
</style>